import React from 'react';
import styled from 'styled-components';

// Conteneur du composant de chargement
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.9);
`;

// Animation du spinner
const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// Texte de chargement
const LoadingText = styled.p`
  margin-top: 20px;
  font-size: 18px;
  color: #555;
  font-weight: 500;
`;

// Composant de chargement
const LoadingScreen = () => {
  return (
    <LoadingContainer>
      <Spinner />
      <LoadingText>Chargement en cours...</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingScreen; 